import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { ErrorMessage } from 'ui/shared/messages';

export const AccessDenied = () => {
    const { t } = useTranslation();
    return (
        <div>
            <ErrorMessage
                message={ t('ERROR.ACCESS_DENIED') }
            />
        </div>
    );
};
